"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInitialDisclose = void 0;
var _react = require("react");
var _useDisclose = require("./useDisclose");
const useInitialDisclose = (props = {}) => {
  const {
    open,
    onClose,
    onOpen,
    onToggle
  } = (0, _useDisclose.useDisclose)(props);
  const [initialOpenDone, setInitialOpenDone] = (0, _react.useState)(props.defaultOpen ?? false);
  const handleOnOpen = (0, _react.useCallback)(() => {
    if (!initialOpenDone) {
      setInitialOpenDone(true);
    }
    onOpen();
  }, [initialOpenDone, onOpen]);
  const handleOnToggle = (0, _react.useCallback)(() => {
    if (!initialOpenDone && !open) {
      setInitialOpenDone(true);
    }
    onToggle();
  }, [initialOpenDone, open, onToggle]);
  return {
    open,
    onClose,
    onOpen: handleOnOpen,
    onToggle: handleOnToggle,
    initialOpenDone
  };
};
exports.useInitialDisclose = useInitialDisclose;
//# sourceMappingURL=useInitialDisclose.js.map